/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Buyer_Signal_TrackingInputs */

const en_buyer_signal_tracking = /** @type {(inputs: Buyer_Signal_TrackingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buyer Signal Tracking`)
};

const es_buyer_signal_tracking = /** @type {(inputs: Buyer_Signal_TrackingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seguimiento de señales del comprador`)
};

const fr_buyer_signal_tracking = /** @type {(inputs: Buyer_Signal_TrackingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suivi des signaux d'achat`)
};

const de_buyer_signal_tracking = /** @type {(inputs: Buyer_Signal_TrackingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Käufer-Signalverfolgung`)
};

const ja_buyer_signal_tracking = /** @type {(inputs: Buyer_Signal_TrackingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`購入者シグナルトラッキング`)
};

const zh_buyer_signal_tracking = /** @type {(inputs: Buyer_Signal_TrackingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`买家信号追踪`)
};

const ar_buyer_signal_tracking = /** @type {(inputs: Buyer_Signal_TrackingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تتبع إشارات المشتري`)
};

const id_buyer_signal_tracking = /** @type {(inputs: Buyer_Signal_TrackingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pelacakan Sinyal Pembeli`)
};

const it_buyer_signal_tracking = /** @type {(inputs: Buyer_Signal_TrackingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tracciamento dei Segnali dell'Acquirente`)
};

const ru_buyer_signal_tracking = /** @type {(inputs: Buyer_Signal_TrackingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Отслеживание сигналов покупателя`)
};

const pt_buyer_signal_tracking = /** @type {(inputs: Buyer_Signal_TrackingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rastreamento de Sinais do Comprador`)
};

const ko_buyer_signal_tracking = /** @type {(inputs: Buyer_Signal_TrackingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`구매자 시그널 트래킹`)
};

/**
* | output |
* | --- |
* | "Buyer Signal Tracking" |
*
* @param {Buyer_Signal_TrackingInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const buyer_signal_tracking = /** @type {((inputs?: Buyer_Signal_TrackingInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Buyer_Signal_TrackingInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_buyer_signal_tracking(inputs)
	if (locale === "es") return es_buyer_signal_tracking(inputs)
	if (locale === "fr") return fr_buyer_signal_tracking(inputs)
	if (locale === "de") return de_buyer_signal_tracking(inputs)
	if (locale === "ja") return ja_buyer_signal_tracking(inputs)
	if (locale === "zh") return zh_buyer_signal_tracking(inputs)
	if (locale === "ar") return ar_buyer_signal_tracking(inputs)
	if (locale === "id") return id_buyer_signal_tracking(inputs)
	if (locale === "it") return it_buyer_signal_tracking(inputs)
	if (locale === "ru") return ru_buyer_signal_tracking(inputs)
	if (locale === "pt") return pt_buyer_signal_tracking(inputs)
	return ko_buyer_signal_tracking(inputs)
});